import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.7964 3.84902C13.124 3.39249 12.3937 3.0404 11.6294 2.80017C10.6651 2.49707 10.1829 2.34552 9.67485 2.72625C9.16669 3.10699 9.16669 3.72542 9.16669 4.96227V8.75533C9.16669 9.80808 9.16669 10.3344 9.36177 10.8063C9.55694 11.2783 9.92685 11.6467 10.6667 12.3837L13.3325 15.0388C14.2018 15.9046 14.6364 16.3375 15.2597 16.2352C15.883 16.1331 16.1139 15.6771 16.5759 14.7652C16.9294 14.0675 17.1876 13.3196 17.3399 12.5416C17.6614 10.899 17.4964 9.1965 16.8657 7.64919C16.2349 6.10193 15.1669 4.77946 13.7964 3.84902Z"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 17.0153C10.8947 17.3278 10.0508 17.4999 9.16667 17.4999C5.48477 17.4999 2.5 14.5152 2.5 10.8333C2.5 7.96914 4.30613 5.52685 6.84157 4.58325"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
